<template>
	<span
		class="font-semibold font-secondary text-neutral-1000 text-2xl whitespace-nowrap group-price max-sm:px-1 flex"
		:class="{'sm:text-3xl': !smallPrice && !onlyLargePrice, '!text-3xl': onlyLargePrice}"
		:aria-label="price == null ? undefined : formatPrice(price)"
		v-html="formatPriceWithSuperscript(price, priceSize)"
	/>
</template>

<script setup lang="ts">
	interface Props {
		price?: number | null
		smallPrice?: boolean
		onlyLargePrice?: boolean
	}

	const props = defineProps<Props>();

	const priceSize = computed(() => {
		if (props.onlyLargePrice) { return 'text-[.875rem] -top-[0.75rem]'; }
		if (props.smallPrice) { return 'text-[.75rem] -top-[.5rem]'; }
		return 'text-[.75rem] -top-[0.5rem] sm:text-[14px] sm:-top-[0.75rem]';
	});
</script>
